<template>
  <div class="previous-year">
    <h2 class="previous-year__title">{{ content.title }}</h2>
    <div class="previous-year__content">
      <div class="previous-year__content__scatter">
        <TvaScatterPlot
          :config="config"
          :data="getOilQualityPreviousYear.scatterData"
          :globalIndex="globalIndex"
          :legendValue="content.legendValues[geoArea]"
        />

        <ScatterLegend
          :icon="content.legend.legendIcon"
          :text="content.legend.text"
        />
        <BottomInfo :label="content.bottomInfo" />
        <ScatterAxisInfo
          v-for="(axe, index) in content.axis"
          :key="'axi-' + index"
          :icon="axe.icon"
          :label="axe.label"
          :xAxis="axe.xAxis"
        />
      </div>
      <TopChart
        :dataArray="getOilQualityPreviousYear.scatterData"
        :label="content.label"
        :globalIndex="globalIndex"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopChart from "./TopChart.vue";
import TvaScatterPlot from "../../charts/TvaScatterPlot.vue";
import ScatterLegend from "./ScatterLegend.vue";
import ScatterAxisInfo from "./ScatterAxisInfo.vue";
import BottomInfo from "./BottomInfo.vue";

export default {
  name: "PreviousYear",
  props: {
    content: { type: Object },
  },
  data() {
    return {
      globalIndex: null,
      config: {
        globalUnitSymbol: "",
        globalDecimals: 0,
        globalLanguage: "en-US",
        globalFixedWidth: null,
        globalFixedHeight: null,
        globalMarginTop: 70,
        globalMarginRight: 170,
        globalMarginBottom: 0,
        globalMarginLeft: 0,
        gridXStrokeColor: "rgba(255, 255, 255, 0.1)",
        gridXStrokeWidth: 1,
        gridXStrokeDash: "0",
        gridYStrokeColor: "rgba(255, 255, 255, 0.1)",
        gridYStrokeWidth: 1,
        gridYBaselineStrokeWidth: 1,
        gridYStrokeDash: "0",
        xAxisHeight: 60,
        xAxisPosition: "bottom",
        xAxisTicksAmount: 5,
        xAxisType: "string",
        xAxisTickHeight: 60,
        xAxisTranslate: { x: 0, y: -37 },
        xAxisTickStrokeColor: "rgba(255, 255, 255, 0.1)",
        xAxisTickStrokeWidth: 1,
        xAxisLabelXOffset: 0,
        xAxisLabelYOffset: 0,
        yAxisWidth: 200,
        yAxisPosition: "left",
        yAxisTicksAmount: 5,
        yAxisType: "string",
        yAxisTickWidth: 60,
        yAxisTickStrokeColor: "rgba(255, 255, 255, 0.1)",
        yAxisTranslate: { x: -129, y: -5 },
        yAxisTickStrokeWidth: 1,
        yAxisLabelAnchor: "end",
        yAxisLabelXOffset: 0,
        yAxisLabelYOffset: 0,
        legendHeight: 0,
        legendPosition: "top",
        legendFontSize: 14,
        series: [
          {
            key: "api",
          },
        ],
        xAxis: "sulphur",
        yAxis: "api",
      },
    };
  },
  computed: {
    ...mapGetters({
      geoArea: "ui/geoArea",
      getOilQualityPreviousYear: "data/getOilQualityPreviousYear",
      lastUpdate: "data/getLastUpdated",
    }),
  },
  components: {
    TopChart,
    TvaScatterPlot,
    ScatterLegend,
    ScatterAxisInfo,
    BottomInfo,
  },
};
</script>

<style lang="scss" scoped>
.previous-year {
  height: 100%;
  width: 100%;

  &__title {
    width: 100%;
    height: $title-drill-height;
    border-bottom: toRem(1) solid $white-02;
    color: $ui-white;
    padding-left: toRem(60);
    @include title-H5;
    line-height: $title-drill-height;
  }

  &__content {
    width: 100vw;
    height: auto;
    display: flex;

    &__scatter {
      width: calc(100vw - toRem(220));
      height: calc(
        100vh - $button-drill-height-open - $switch-drill-height -
          $switch-drill-height - $title-drill-height
      );
      z-index: 50;
      position: relative;
    }
  }
}
</style>
